import React, { useEffect, useRef, useState } from 'react';


export default function AnimatedCounter({ from = 0, to = 100, duration = 1200, prefix = '', suffix = '', decimals = 0 }) {
    const [value, setValue] = useState(from);
    const ref = useRef();


    useEffect(() => {
        let observer;
        const el = ref.current;
        const animate = () => {
            const start = performance.now();
            const change = to - from;
            const run = (t) => {
                const p = Math.min((t - start) / duration, 1);
                const eased = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; // simple ease
                const v = from + change * eased;
                setValue(Number(v.toFixed(decimals)));
                if (p < 1) requestAnimationFrame(run);
            };
            requestAnimationFrame(run);
        };


        if (el) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animate();
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.5 });
            observer.observe(el);
        }


        return () => observer && observer.disconnect();
    }, [from, to, duration, decimals]);


    return <div ref={ref} className="animated-counter">{prefix}{value}{suffix}</div>;
}